var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-reader", {
    attrs: { entity: "plot", id: _vm.id, "use-sharing": true },
    scopedSlots: _vm._u(
      [
        {
          key: `reader`,
          fn: function({ doc }) {
            return [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("div", { staticClass: "text-h5" }, [
                      _vm._v(_vm._s(doc.name))
                    ])
                  ])
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("div", {
                      staticClass: "wrap-html",
                      domProps: { innerHTML: _vm._s(doc.details) }
                    })
                  ])
                ],
                1
              )
            ]
          }
        },
        {
          key: `extraTabs`,
          fn: function() {
            return [
              _c("v-tab", [_vm._v(" Monsters ")]),
              _c("v-tab", [_vm._v(" Encounters ")])
            ]
          },
          proxy: true
        },
        {
          key: `extraTabItems`,
          fn: function({ userPermissions }) {
            return [
              _c(
                "v-tab-item",
                [
                  _c("monster-manager", {
                    attrs: { id: _vm.id, permissions: userPermissions }
                  })
                ],
                1
              ),
              _c(
                "v-tab-item",
                [_c("encounter-list", { attrs: { id: _vm.id } })],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }